import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { createClerkProvider } from './clerk';
import { setSwRegistration } from './swUpdateService';
const container = document.getElementById('root');
if (!container) {
    throw new Error('Root element not found');
}
async function bootstrap() {
    const root = createRoot(container);
    const appShell = (React.createElement(React.StrictMode, null,
        React.createElement(App, null)));
    root.render(createClerkProvider(appShell));
}
bootstrap();
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/service-worker.js', { updateViaCache: 'none' })
            .then((registration) => {
            setSwRegistration(registration);
            // If no waiting SW, any persisted acceptance flag is stale (the update
            // already applied in a prior session). Clear it so the next update shows
            // the banner correctly. This also handles the one-time migration where
            // the old controllerchange handler didn't clear the flag itself.
            if (!registration.waiting) {
                localStorage.removeItem('sw-update-accepted');
            }
            const isPwa = window.matchMedia('(display-mode: standalone)').matches
                || navigator.standalone === true;
            const notifyUpdate = () => {
                if (!isPwa)
                    return;
                if (localStorage.getItem('sw-update-accepted')) {
                    // User already accepted - re-send SKIP_WAITING in case the app
                    // was killed before it completed, then wait for controllerchange.
                    registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
                    return;
                }
                window.dispatchEvent(new CustomEvent('sw-update-available'));
            };
            if (registration.waiting && navigator.serviceWorker.controller) {
                notifyUpdate();
            }
            registration.addEventListener('updatefound', () => {
                const newWorker = registration.installing;
                if (!newWorker)
                    return;
                newWorker.addEventListener('statechange', () => {
                    if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                        notifyUpdate();
                    }
                });
            });
        })
            .catch((err) => {
            console.warn('SW registration failed:', err);
        });
    });
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        // Update successfully applied - clear the flag before reloading so the
        // banner doesn't fire on the fresh page load.
        localStorage.removeItem('sw-update-accepted');
        if (refreshing)
            return;
        refreshing = true;
        window.location.reload();
    });
}
